{
  "alignment": {
    "attestedIn": "attested in",
    "noDecision": "No mapping and no \"no reference match\" reason recorded.",
    "noDefinition": "No definition.",
    "noEvidence": "no original-text evidence",
    "noReferenceMatch": "No reference match:",
    "note": "Each new term beside the concepts it maps to in the bound reference vocabularies ({{vocabularies}}). Whether two definitions mean the same is your judgement: send the change back, or acknowledge a deliberate difference with a reason.",
    "parentDifference": "Parent differs:",
    "parents": "Parents: {{parents}}",
    "proposed": "Proposed term",
    "reference": "Reference concept",
    "title": "Reference alignment",
    "unknownConcept": "No bound reference vocabulary declares this concept.",
    "unreadable": "Could not read a reference vocabulary: {{problem}}"
  },
  "changes": {"added": "new", "modified": "changed", "removed": "removed"},
  "checks": {
    "findingCounts": "{{shown}} shown · {{listed}} listed · {{total}} in total",
    "findings_one": "{{count}} finding",
    "findings_other": "{{count}} findings",
    "kinds": {
      "competency_question": "Question",
      "consistency": "Consistency",
      "run": "Run",
      "shapes": "Shapes",
      "test_data": "Test data",
      "unsatisfiable_classes": "Unsatisfiable classes"
    },
    "notRun": "This version has not been checked.",
    "process": "Process checks",
    "processNote": "Shapes and questions of the process graph: conventions, reuse and the lifecycle of the process items. New shapes violations must be revised before merging; pre-existing violations need your acknowledgement.",
    "questionCoverage_one": "{{count}} question: {{checked}} checked, {{notChecked}} not checked.",
    "questionCoverage_other": "{{count}} questions: {{checked}} checked, {{notChecked}} not checked.",
    "ruleSet_one": "Ran the {{name}}: {{count}} rule. A pass means only that this rule found nothing.",
    "ruleSet_other": "Ran the {{name}}: {{count}} rules. A pass means only that these rules found nothing.",
    "status": {
      "cannot_run": "Could not run",
      "fail": "Fail",
      "not_checked": "Not checked",
      "pass": "Pass"
    },
    "title": "Checks of this version"
  },
  "collaboration": {
    "bulk": {
      "keepConfirm_one": "Keep {{count}} new term",
      "keepConfirm_other": "Keep {{count}} new terms",
      "keepOffer_one": "Keep {{count}} new term scored below {{threshold}}",
      "keepOffer_other": "Keep {{count}} new terms scored below {{threshold}}",
      "keepRow": "{{term}} may duplicate {{target}} (score {{score}})",
      "markConfirm_one": "Mark {{count}} section as reviewed now",
      "markConfirm_other": "Mark {{count}} sections as reviewed now",
      "markOffer_one": "Mark {{count}} section as reviewed",
      "markOffer_other": "Mark {{count}} sections as reviewed",
      "nothing": "Nothing here is safe to decide in bulk. Sections with findings, possible duplicates or failing checks are decided one by one.",
      "reason": "Why these are no duplicates",
      "title": "Decide in bulk"
    },
    "inbox": {
      "approved": "Every item approved",
      "askedBy": "Asked by {{names}}",
      "badge_one": "{{count}} thing waits for you",
      "badge_other": "{{count}} things wait for you",
      "checks": {"cannot_run": "Checks could not run", "fail": "Checks fail"},
      "duplicates_one": "{{count}} possible duplicate to resolve",
      "duplicates_other": "{{count}} possible duplicates to resolve",
      "effect": {
        "approve_one": "Review · Approve {{count}} change",
        "approve_other": "Review · Approve {{count}} changes",
        "basis": "DMW basis · Approve the library update",
        "review_one": "Review · Inspect {{count}} change",
        "review_other": "Review · Inspect {{count}} changes",
        "revise_one": "Proposal · Revise {{count}} change",
        "revise_other": "Proposal · Revise {{count}} changes"
      },
      "sections": {
        "myOpenProposals": {"shelf": "My open proposals ({{count}})"},
        "waitingForMe": {"title": "Input"}
      },
      "sentBackBy": "Sent back by {{name}}:",
      "toApprove": "Your approval",
      "waitingApprovals_one": "Waits for {{count}} approval",
      "waitingApprovals_other": "Waits for {{count}} approvals"
    },
    "labels": {
      "added": "Added: {{name}}",
      "byHand": "Written by hand: no generation rules apply, so there is nothing to keep in step.",
      "changed": "Changed: {{name}}",
      "decide": "Needs a decision",
      "dropLink": "Drop the link",
      "fields": {
        "description": "Description",
        "examples": "Examples",
        "guidelines": "Guidelines",
        "name": "Name",
        "ontology_terms": "Ontology terms"
      },
      "labels": "Labels",
      "linkRemoved": "{{label}} links {{term}}, which this change set removes.",
      "linkRenamed": "{{label}} links {{term}}, which this change set renames to {{renamedTo}}.",
      "noLabelChange": "No label changed.",
      "nothingToDecide": "Every label links terms that stay.",
      "removed": "Removed: {{name}}",
      "retarget": "Link {{term}} instead",
      "rules": "Rules",
      "unchanged_one": "{{count}} label unchanged",
      "unchanged_other": "{{count}} labels unchanged"
    },
    "presence": {
      "at": "{{name}}, at {{unit}}",
      "here": "Here now:",
      "isHere": "Also here: {{names}}",
      "label": "Who has this review open",
      "newHead": "This change set has a new version since you opened it. Marks on sections that did not change still count.",
      "reload": "Reload"
    },
    "requests": {
      "ask": "Ask someone to look",
      "asked": "{{from}} asked {{to}}",
      "choose": "Choose a member",
      "curates": "{{name}}, curates {{items}}",
      "decline": "Decline",
      "declineReason": "Why you decline",
      "nobody": "No other member is in this project.",
      "note": "What should they look at?",
      "scope": "What to look at",
      "send": "Ask",
      "states": {"declined": "Declined", "done": "Done", "open": "Open", "withdrawn": "Withdrawn"},
      "thisUnit": "This section",
      "title": "Asked to look",
      "units_one": "{{count}} section",
      "units_other": "{{count}} sections",
      "whole": "Whole change set",
      "whom": "Whom to ask",
      "withdraw": "Withdraw"
    }
  },
  "conflicts": {
    "derivedSourceChanged": "is built from what this change changes. Run what builds it again after the merge.",
    "none": "This change touches nothing that other items rely on.",
    "notRun": "Not checked for conflicts yet.",
    "regressed": "The check “{{check}}” passed before and fails now.",
    "regressedItem": "Its check passed before and fails now.",
    "regressedUnnamed": "A check passed before and fails now.",
    "reliesOn": "relies on",
    "renamed": "{{term}} is now probably {{renamedTo}}",
    "rerun": "Check again",
    "rules": "Checked with rules {{version}}",
    "title": "Conflicts",
    "unused": "{{term}}: {{changes}}; nothing connected uses it.",
    "via": "through what it pins"
  },
  "curation": {
    "actionBar": "Actions on this section",
    "actions": {"add": "Add", "replace": "Replace", "skip": "Skip"},
    "affectedExplained": "The change set does not touch this item, but it uses terms the change set changes. You may comment; it does not block.",
    "after": "After",
    "before": "Before",
    "candidates": {
      "apply": "Apply",
      "dismiss": "Not a duplicate…",
      "dismissReason": "Why it is no duplicate",
      "dismissSend": "Dismiss",
      "inModule": "in {{name}}",
      "none": "No possible duplicates",
      "propose": "May duplicate another term…",
      "readOnly": "Only someone who may propose changes can resolve this.",
      "reason": "Reason (optional)",
      "resolution": "Resolution",
      "suggestsMerge": "Suggested: merge",
      "target": "Possible duplicate of",
      "title_one": "{{count}} possible duplicate",
      "title_other": "{{count}} possible duplicates"
    },
    "changes": {"added": "new", "changed": "changed", "removed": "removed"},
    "columns": {"context": "Context", "outline": "Outline"},
    "comment": "Comment",
    "compare": {
      "caption": "{{term}} and {{target}}, field by field",
      "choice": "When merging",
      "field": "Field",
      "hideSame": "Hide identical fields",
      "newTerm": "New: {{name}}",
      "nothingToAdd": "nothing to add",
      "showSame_one": "Show {{count}} identical field",
      "showSame_other": "Show {{count}} identical fields",
      "target": "Existing: {{name}}"
    },
    "context": {
      "decides": "Who decides",
      "discussion": "Discussion",
      "label": "Context of this section",
      "marks": "Marks",
      "othersCurate": "curated by others",
      "outdated": "earlier version",
      "youCurate": "you curate it"
    },
    "decide": {
      "unmarked_one": "{{count}} of your sections is not marked as reviewed. Approve anyway?",
      "unmarked_other": "{{count}} of your sections are not marked as reviewed. Approve anyway?"
    },
    "download": {
      "markdown": "Proposal as Markdown",
      "open": "Download",
      "turtle": "{{name}} as Turtle"
    },
    "edit": {
      "explain": "Saves a new version of this change set. Checks and the conflict check run again; marks on sections that did not change stay.",
      "open": "Edit Turtle",
      "save": "Save as a new version",
      "title": "Edit {{name}}"
    },
    "evidence": {
      "lexical": "Names",
      "rationale": "Rationale",
      "semantic": "Meaning",
      "structural": "Structure",
      "usage": "Use"
    },
    "explain": {
      "drop_new": "Removes every statement that names {{term}} from this change set, and its label-list links. Refused while a question of the change set asks about it.",
      "keep_new": "Keeps {{term}} as a term of its own.",
      "merge_into": "Removes {{term}}, writes {{target}} wherever the change set used it (ontology modules, shapes, examples, questions, label lists), and applies the field choices to {{target}}."
    },
    "fields": {
      "altLabel": "Alternative label",
      "comment": "Comment",
      "definedBy": "Defined by",
      "definition": "Definition",
      "domain": "Domain",
      "example": "Example",
      "label": "Label",
      "parent": "Parent",
      "range": "Range",
      "seeAlso": "See also"
    },
    "fieldsCaption": "{{name}}, field by field, before and after",
    "focusLabel": "Section in focus",
    "itemSentence": {
      "added": "Adds {{name}}.",
      "modified": "Changes {{name}}.",
      "removed": "Removes {{name}}."
    },
    "keep": {
      "module": "Ontology module",
      "moduleUnchanged": "Stays in {{name}}",
      "narrower": "as a narrower term of {{target}}"
    },
    "keys": {
      "close": "Close the note or help",
      "columns": "Hide or show the outline and the context",
      "comment": "Comment on this section",
      "decide": "Approve, request changes, merge",
      "filter": "Filter the outline",
      "help": "Show the keys",
      "needsChange": "Needs change, with a note",
      "ok": "Mark as reviewed",
      "resolve": "Keep new, merge into, drop new",
      "technical": "Technical details on or off",
      "title": "Keyboard shortcuts",
      "units": "Next or previous section",
      "unresolved": "Next or previous unresolved section"
    },
    "kinds": {
      "affected": "item",
      "checks": "check",
      "classes": "class",
      "conversation": "review overview",
      "individuals": "individual",
      "items": "item",
      "properties": "property",
      "terms": "term"
    },
    "marks": {
      "clearOk": "Marked as reviewed · undo",
      "needsChange": "Needs change",
      "notYours": "You curate no item of this section.",
      "note": "What needs to change",
      "ok": "Reviewed",
      "sendNote": "Send",
      "short": {"needs_change": "needs change", "ok": "reviewed"}
    },
    "nextUnresolved": "Next unresolved",
    "openDecisions_one": "{{count}} open decision",
    "openDecisions_other": "{{count}} open decisions",
    "otherAdded_one": "{{count}} other statement added",
    "otherAdded_other": "{{count}} other statements added",
    "otherRemoved_one": "{{count}} other statement removed",
    "otherRemoved_other": "{{count}} other statements removed",
    "outline": {
      "conversation": "Review overview",
      "duplicate": "possible duplicate",
      "filter": {
        "all": "All",
        "duplicates": "Possible duplicates",
        "needs_me": "Needs me",
        "open": "Open"
      },
      "filters": "Show",
      "groups": {
        "affected": "Affected items",
        "checks": "Checks",
        "classes": "Classes",
        "conversation": "Review overview",
        "individuals": "Individuals",
        "items": "Items",
        "properties": "Properties",
        "terms": "Other terms"
      },
      "label": "Review outline",
      "needsMe": "needs you",
      "search": "Filter sections",
      "units": "Review sections"
    },
    "rename": {
      "explain": "Writes the new IRI in every ontology module and in this change set's own examples, questions and label lists, as one new version.",
      "label": "New IRI",
      "open": "Rename IRI…",
      "send": "Rename"
    },
    "resolutions": {
      "drop_new": "3 · Drop new",
      "keep_new": "1 · Keep new",
      "merge_into": "2 · Merge into {{target}}"
    },
    "resolved": {
      "drop_new": "Dropped by {{name}}",
      "dropped_one": "{{count}} statement dropped without a replacement",
      "dropped_other": "{{count}} statements dropped without a replacement",
      "item": "{{name}}: {{uses}}, {{added}} added, {{removed}} removed",
      "keep_new": "Kept apart from {{target}} by {{name}}",
      "merge_into": "Merged into {{target}} by {{name}}",
      "noCommit": "Nothing to change: no new version.",
      "uses_one": "{{count}} use rewritten",
      "uses_other": "{{count}} uses rewritten"
    },
    "scores": {
      "lexical": "names {{value}}",
      "semantic": "meaning {{value}}",
      "structural": "structure {{value}}"
    },
    "sentence": {
      "added": "Adds the {{kind}} {{name}}",
      "changed": "Changes the {{kind}} {{name}}",
      "parents": ", a kind of {{names}}",
      "removed": "Removes the {{kind}} {{name}}"
    },
    "sources": {
      "agent_turn": "Proposed by an agent in a Run",
      "builtin_lexical": "Found by DMW's name matcher",
      "person": "Proposed by a person",
      "tool_run": "Found by an equivalence check in a Run"
    },
    "states": {
      "dismissed": "Not a duplicate of {{target}}",
      "open": "Possible duplicate of {{target}}",
      "resolved": "Resolved: {{target}}",
      "superseded": "No longer applies: the term changed ({{target}})"
    },
    "technical": "Technical details",
    "technicalMore_one": "{{count}} more statement is not listed.",
    "technicalMore_other": "{{count}} more statements are not listed.",
    "usedByNone": "No connected item uses it.",
    "usedBy_one": "Used by {{count}} item",
    "usedBy_other": "Used by {{count}} items"
  },
  "decisions": {
    "acknowledged": "acknowledged: {{note}}",
    "actions": {"approve": "Approve", "request_changes": "Send back", "scrap": "Scrap"},
    "barLabel": "Your decision",
    "by": "by {{name}} {{time}}",
    "byYou": "by you {{time}}",
    "commentFor": {
      "approve": "Comment (optional)",
      "merge": "Why merge this version?",
      "request_changes": "What should change?",
      "resubmit": "What did you change? (optional)",
      "scrap": "Why scrap it?"
    },
    "external": {
      "author": "Original author: {{name}}",
      "explanation": "Historical evidence; these decisions do not count as local approvals.",
      "head": "Version originally reviewed: {{head}}",
      "invited": "invited account; email not verified",
      "matched": "verified account match",
      "title": "Imported review history",
      "unmatched": "unmatched external reviewer"
    },
    "kinds": {
      "approve": "Approved",
      "merge": "Merged",
      "request_changes": "Changes requested",
      "scrap": "Scrapped"
    },
    "mergeApprovals": {"by": "after approval by {{names}}", "none": "without a separate approval"},
    "none": "No curator has decided yet.",
    "notCurator": "You curate none of the changed items, so you can discuss but not decide.",
    "outdated": "on an earlier version",
    "resubmit": "Resubmit for review",
    "resubmitReason": "Changes made as requested.",
    "title": "Decisions"
  },
  "fold": {
    "fold": "Consolidate into it",
    "keep": "Keep",
    "open": "Consolidate…",
    "question": "Wording",
    "submit": "Consolidate"
  },
  "graphDiff": {
    "abstractStep": "abstract step",
    "binding": "link {{target}} ← {{source}}",
    "bindings": "Links",
    "inputs": "Inputs",
    "pipeline": "Main sequence",
    "subWorkflow": "sub-schema"
  },
  "inThread": {
    "decidedIn": "Decided in its Run",
    "elsewhere": "Another Run decides this change set; answers are given there.",
    "noChangeSet": "This review step's input names no change set yet.",
    "openOwner": "Open that Run"
  },
  "index": {
    "conflicts_one": "{{count}} conflict",
    "conflicts_other": "{{count}} conflicts",
    "items_one": "{{count}} item",
    "items_other": "{{count}} items"
  },
  "item": {
    "added_one": "{{count}} statement added",
    "added_other": "{{count}} statements added",
    "approvedBy": "approved by {{names}}",
    "axiom": "an axiom",
    "changedFields": "Changed fields: {{fields}}",
    "discussion": "Discussion of this item",
    "fieldDiff": "Changed fields",
    "graphDiff": "Process schema graph",
    "loadingDefinition": "Reading both versions…",
    "loadingText": "Loading the texts…",
    "lookedAt": "I have looked at this",
    "notApproved": "not approved yet",
    "openNew": "Open the proposed version",
    "openOld": "Open the previous version",
    "removed_one": "{{count}} statement removed",
    "removed_other": "{{count}} statements removed",
    "textFields": {
      "body": "Instructions",
      "content": "Content",
      "description": "Description",
      "text": "Text"
    },
    "wholeAdded": "New item: open it to read the whole definition.",
    "wholeRemoved": "Removed item: open the earlier version to read it."
  },
  "kinds": {"corpus": "Corpus", "knowledge_data": "Knowledge data"},
  "levels": {
    "check": "Needs inspection",
    "checkExplained_one": "{{count}} relies on something whose meaning changed",
    "checkExplained_other": "{{count}} rely on something whose meaning changed",
    "conflict": "Conflict",
    "conflictExplained_one": "{{count}} relies on something that is gone or now contradicts it",
    "conflictExplained_other": "{{count}} rely on something that is gone or now contradicts them",
    "info": "Info",
    "infoExplained_one": "{{count}} for information: nothing connected uses it",
    "infoExplained_other": "{{count}} for information: nothing connected uses them"
  },
  "lifecycle": {
    "deprecatedNote": "Still runs, but new pins are flagged. Move to the replacement.",
    "noReplacement": "Nothing replaces it.",
    "reason": "Reason: {{reason}}",
    "replacedBy": "Replaced by",
    "retiredNote": "Starts no new Run or batch; work already running finishes, and its results stay valid.",
    "state": {
      "active": "Active",
      "deprecated": "Deprecated",
      "draft": "Draft",
      "retired": "Retired",
      "withdrawn": "Withdrawn"
    },
    "withdrawnNote": "Withdrawn as wrong or unsafe: nothing runs it any more, and running Runs stop before their next turn. Its results are listed for re-review."
  },
  "merge": {
    "acknowledge": "I have seen the open findings above and merge anyway.",
    "action": "Merge this version",
    "note": "Why merging is right despite them (recorded with the merge)",
    "waiting_one": "{{count}} item still needs its curator's approval.",
    "waiting_other": "{{count}} items still need their curators' approval."
  },
  "mergeBlocks": {
    "explanation": "Revise the data model, its shapes or its test data before merging. Send this version back with the findings below.",
    "inconsistent": "Inconsistent checks:",
    "introduced": "New shapes violations, and test data the change breaks:",
    "maintained": "Kept up to date, not rebuilt with this change yet:",
    "maintainedCycle_one": "{{count}} item kept up to date is built from itself.",
    "maintainedCycle_other": "{{count}} items kept up to date are built from each other.",
    "maintainedFix": {
      "change_declaration": "{{name}} cannot be built: {{problem}}.",
      "rebuild": "{{name}}: waits for its rebuild.",
      "update_from_main": "{{name}}: the main version changed what it is built from. Update this change from it."
    },
    "more_one": "and {{count}} more",
    "more_other": "and {{count}} more",
    "noFocus": "Focus not specified",
    "openRebuild": "Open the rebuild",
    "preExisting": "Already in the base version; these do not block merging:",
    "preExistingCount_one": "{{count}} violation was already in the base version; it does not block merging.",
    "preExistingCount_other": "{{count}} violations were already in the base version; they do not block merging.",
    "rebuildHere": "Rebuild on my PC",
    "rebuildState": {
      "failed": "The rebuild failed: {{problem}}",
      "running": "The rebuild is running.",
      "waiting_for_host": "The rebuild waits for its host's PC to come online."
    },
    "title": "This version cannot be merged",
    "uncompared": "Not compared with the base version, since these checks list only part of their violations or the base version lacks them; their findings need the acknowledgement instead: {{checks}}",
    "updateFromMain": "Update from main"
  },
  "page": {
    "changes_one": "{{count}} changed item",
    "changes_other": "{{count}} changed items",
    "copyHead": "Copy the commit of this version",
    "discussion": "Discussion of the whole change set",
    "mergedInto": "Merged into {{project}}",
    "mergesInto": "Merges into {{project}}",
    "proposed": "Proposed by {{name}} {{time}}",
    "proposedByYou": "Proposed by you {{time}}",
    "savedFrom": "Saved from Run",
    "termDiscussions": "Comments and issues on the terms it touches",
    "threadEntry": "Run entry {{number}}"
  },
  "predicates": {
    "allValuesFrom": "to only",
    "comment": "is described as",
    "disjointWith": "is never also",
    "domain": "applies to",
    "equivalentClass": "is the same as",
    "inverseOf": "is the inverse of",
    "label": "is labelled",
    "onProperty": "restricts",
    "range": "points to",
    "someValuesFrom": "to some",
    "subClassOf": "is a kind of",
    "subPropertyOf": "is a narrower form of",
    "type": "is a"
  },
  "states": {
    "merged": "Merged",
    "open": "Waiting for review",
    "scrapped": "Scrapped",
    "sent_back": "Sent back"
  },
  "summary": {
    "approvalsMissing_one": "{{count}} item still needs a curator's approval",
    "approvalsMissing_other": "{{count}} items still need a curator's approval",
    "blocking_one": "{{count}} finding needs attention before merging",
    "blocking_other": "{{count}} findings need attention before merging",
    "closed": {
      "merged": "Findings below are as they were at the merge.",
      "scrapped": "A contributor can reopen it."
    },
    "nothingBlocking": "No conflicts and no failing checks",
    "openItems_one": "{{count}} item to look at",
    "openItems_other": "{{count}} items to look at"
  },
  "termChanges": {
    "added": "new",
    "definition_changed": "definition changed",
    "hierarchy_changed": "superclass or subclasses changed",
    "label_changed": "label changed",
    "other_changed": "other details changed",
    "removed": "removed",
    "renamed": "renamed",
    "signature_changed": "domain, range or restriction changed"
  },
  "unnamedTerm": "No label",
  "you": "you"
}
